export enum FormConditionType {
  weather = 'weather',
  cistern = 'cistern',
  clockTime = 'clockTime',
  soil = 'soil'
}
